import { useHasScope } from "../../../../utils/Permission";

type Props =
    {
        allSelected: boolean
        onToggleAll: () => void
        hasDetails?: boolean
    }

export default function StoreReportRowHeader({ allSelected, onToggleAll, hasDetails = true }: Props) {
    const canSeeDetails = useHasScope('reports:view-details');
    const canSelectRows = useHasScope(['stores:create', 'write-force-sync'], true);

    return (
        <div className="list-item headerItems">
            <div className="item-line">
                {canSelectRows && (
                    <div className="item-column header selectItem">
                        <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={onToggleAll}
                            aria-label="Select every row on this page"
                        />
                    </div>
                )}
                <div className="item-column header nameItem">Name</div>
                {canSeeDetails && <div className="item-column header idItem">RS ID</div>}
                <div className="item-column header shopifyItem">Shopify ID</div>
                <div className="item-column header productItem">Handle</div>
                <div className="item-column header statusItem">Status</div>
                {canSeeDetails && <div className="item-column header actionItem">Action</div>}
                <div className="item-column header updatedItem">Updated (UTC)</div>
                {canSeeDetails && hasDetails && <div className="item-column header detailItem"></div>}
            </div>
        </div>
    )
}
